import "./Layout.scss";

function MainLayout(props) {
  const { children } = props;
  return <div className="main-layout">{children}</div>;
}

export default MainLayout;
